var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"id":"briller-logo-banner"}},[_c('router-link',{attrs:{"to":"/"}},[_c('div',{staticClass:"image-center"},[_c('img',{staticClass:"briller-banner-logo",attrs:{"src":require('@/assets/briller/briller_logo.png'),"alt":"Briller-ブルイエ-のアイコン","height":"98","width":"300"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }